<button
  class="ui-list-row"
  type="button"
  [class.ui-list-row-dense]="dense()"
  [disabled]="disabled()"
  (click)="handleSelected($event)"
>
  <span class="ui-list-row-leading">
    <ng-content select="[uiListRowLeading]" />
  </span>
  <span class="ui-list-row-copy">
    @if (hasMeta()) {
      <span class="ui-list-row-meta">{{ meta() }}</span>
    }
    <span class="ui-list-row-title">{{ title() }}</span>
    @if (hasSubtitle()) {
      <span class="ui-list-row-subtitle">{{ subtitle() }}</span>
    }
  </span>
  <span class="ui-list-row-trailing">
    <ng-content select="[uiListRowTrailing]" />
  </span>
</button>
